module.exports = __webpack_public_path__ + "img/search-logo.d7e640ed.png";